import React from 'react';
import { useAuth } from '../AuthContext';
import ManagerPayslipView from '../components/payslips/ManagerPayslipView';
import EmployeePayslipView from '../components/payslips/EmployeePayslipView';

const PayslipsPage = () => {
  const { user, isManager } = useAuth();

  if (!user) {
    return <div className="p-4 text-center">Chargement de l'utilisateur...</div>;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">
          {isManager ? 'Gestion des Fiches de Paie' : 'Mes Fiches de Paie'}
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          {isManager
            ? 'Envoyez et gérez les fiches de paie des employés.'
            : 'Consultez et téléchargez vos fiches de paie mensuelles.'}
        </p>
      </div>

      {isManager ? <ManagerPayslipView /> : <EmployeePayslipView />}
    </div>
  );
};

export default PayslipsPage;
